import React, { Fragment, useMemo, useState } from 'react';
import moment from 'moment';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import CartIcon from '@material-ui/icons/ShoppingCartOutlined';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Grid from '@material-ui/core/Grid';
import CheckIcon from '@material-ui/icons/CheckCircleOutline';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Divider from '@material-ui/core/Divider';
import { _T } from 'appI18n';
import Cost from 'react-components/Cost';
import TourAvailabilityDatePicker from 'react-components/AvailabilityDatePicker';
import { TouristPickerWithPlaceDialog } from '../../../include/react-components/TouristPicker/TouristPickerDialog';
import { TouristPickerWithPlaceTextField } from '../../../include/react-components/TouristPicker/TouristPickerTextField';
const useStyles = makeStyles(theme => ({
    root: {
        background: '#edf2f7',
        padding: theme.spacing(1),
        borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
        border: '1px solid #c1ceda',
        borderTop: 0,
        borderLeft: 0,
        borderRight: '1px solid #cdd7e0',
        width: '100%',
    },
    form: {
        '& > :not(:last-child)': {
            marginBottom: theme.spacing(2),
        },
    },
    arrow: {
        position: 'absolute',
        fontSize: 7,
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: 0,
            height: 0,
            borderStyle: 'solid',
            borderWidth: '1em 0 1em 1em',
            borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
        },
        right: 0,
        marginRight: '-0.9em',
        height: '3em',
        width: '1em',
        filter: 'drop-shadow(1px 2px 1px rgba(0,0,0,.08)) drop-shadow(1px 1px 0 rgba(0,0,0,.1))',
    },
    errorText: {
        color: theme.palette.error.main,
    },
    pickersContainer: {
        '& > :not(:last-child)': {
            marginBottom: theme.spacing(1),
        },
    },
    priceContainer: {
        marginTop: theme.spacing(1),
    },
    transportContainer: {},
    currentTransport: {
        display: 'flex',
        alignItems: 'center',
        padding: '4px 0 8px',
        marginLeft: 4,
        color: theme.palette.success.main,
        '& > :last-child': { marginRight: theme.spacing(.5) }
    },
    pricePrefix: {
        color: theme.palette.grey[800]
    }
}));
function labelFunc(date) {
    return date ? date.format('L') : _T.EXCURSION_CHOOSE_EXCURSION_DATE;
}
export default function ExcursionToolbar(props) {
    const classes = useStyles();
    const [touristPickerOpen, setTouristPickerOpen] = useState(false);
    const [pickerRef, setPickerRef] = useState(null);
    const [arrowRef, setArrowRef] = useState(null);
    const maxDate = useMemo(() => moment().add(1, 'year').day(31).format('YYYY-MM-DD'), []);
    const [hintOpen, setHintOpen] = useState(false);
    const sortedPrices = useMemo(() => (props.prices || []).sort((a, b) => a.price - b.price), [props.prices]);
    const showTransport = sortedPrices.length > 1 || (sortedPrices.length == 1 && sortedPrices[0].vehicleTypeName);
    const handleTouristsChanged = (adultCount, childAges) => props.onChange(props.date, adultCount, childAges, props.price);
    const handleDateChanged = (date) => props.onChange(date, props.adultCount, props.childAges, props.price);
    const handleTransportChanged = (price) => props.onChange(props.date, props.adultCount, props.childAges, price);
    const handleAddToCart = () => {
        if (props.date) {
            props.onBook();
            setHintOpen(false);
        }
        else {
            setHintOpen(true);
        }
    };
    const popperModifiers = {
        arrow: { enabled: true, element: arrowRef },
        preventOverflow: { boundariesElement: 'viewport' },
        offset: { enabled: true, offset: '0, 6' },
    };
    return React.createElement("div", { className: classes.root },
        React.createElement(Grid, { container: true },
            React.createElement(Grid, { item: true, lg: 8, md: 8, xs: 12, className: classes.form },
                React.createElement("div", { className: classes.pickersContainer },
                    React.createElement("div", null,
                        React.createElement(TourAvailabilityDatePicker, { fieldLabel: _T.EXCURSION_DATE, calendarLabel: _T.EXCURSION_DATE, labelFunc: labelFunc, date: props.date, maxDate: maxDate, adornment: !props.date ? React.createElement(ErrorIcon, { className: classes.errorText }) : null, fullWidth: true, onChange: handleDateChanged, onAvailabilityRequested: props.onAvailabilityRequest, ref: setPickerRef }),
                        React.createElement(Popper, { placement: "bottom", open: hintOpen, anchorEl: pickerRef, modifiers: popperModifiers, transition: true }, ({ TransitionProps }) => (React.createElement(ClickAwayListener, { onClickAway: () => setHintOpen(false) },
                            React.createElement(Fade, Object.assign({}, TransitionProps, { timeout: 100 }),
                                React.createElement("div", null,
                                    React.createElement("div", { className: classes.arrow, ref: setArrowRef }),
                                    React.createElement(Paper, null,
                                        React.createElement(Box, { p: 2, display: "grid", gridGap: 8, gridTemplateColumns: "auto auto", alignItems: "center" },
                                            React.createElement(ErrorIcon, { htmlColor: "#ff0000" }),
                                            " ",
                                            _T.EXCURSION_ERROR_CANT_BOOK_WITHOUT_DATE)))))))),
                    React.createElement("div", null,
                        React.createElement(TouristPickerWithPlaceTextField, { adultCount: props.adultCount, childAges: props.childAges, fullWidth: true, onClick: () => setTouristPickerOpen(true) }),
                        touristPickerOpen &&
                            React.createElement(TouristPickerWithPlaceDialog, { open: touristPickerOpen, adultCount: props.adultCount, childAges: props.childAges, onChange: handleTouristsChanged, onClose: () => setTouristPickerOpen(false) }) || null)),
                showTransport &&
                    React.createElement(Paper, { className: classes.transportContainer, elevation: 0, variant: "outlined" },
                        React.createElement(Box, { p: 2 },
                            React.createElement(Typography, { variant: "subtitle1", gutterBottom: true }, _T.EXCURSION_AVAILABLE_TRANSPORT_TYPES),
                            React.createElement(Box, { mt: 3 }, sortedPrices.map((x, i) => React.createElement(Fragment, { key: `${x.id}-${x.vehicleTypeId}` },
                                React.createElement(Grid, { container: true },
                                    React.createElement(Grid, { item: true, sm: 8 }, x.vehicleTypeName || null),
                                    React.createElement(Grid, { item: true, xs: 2 },
                                        React.createElement(Cost, { amount: x.price, currency: x.currency.name, amountVariant: "h6" })),
                                    React.createElement(Grid, { item: true, xs: 2 }, x != props.price
                                        ? React.createElement(Button, { color: "secondary", variant: "outlined", fullWidth: true, onClick: handleTransportChanged.bind(null, x) },
                                            _T.COMMON_CHOOSE,
                                            " ",
                                            React.createElement(ChevronRightIcon, null))
                                        : React.createElement(Typography, { className: classes.currentTransport, variant: "button", component: "div" },
                                            React.createElement(CheckIcon, null),
                                            " ",
                                            _T.TOUR_SELECTED))),
                                sortedPrices.length - 1 > i && React.createElement(Box, { my: 1 },
                                    React.createElement(Divider, null)) || null))))),
                React.createElement("div", { className: classes.priceContainer },
                    !props.loading && props.price
                        ? React.createElement(Typography, { variant: "h5" },
                            React.createElement("span", { className: classes.pricePrefix },
                                _T.COMMON_TO_PAY,
                                ": "),
                            React.createElement(Cost, { amount: props.price.price, currency: props.price.currency.name, amountVariant: "h4", currencyVariant: "h5", component: "span" })) : null,
                    !props.loading && props.prices && props.prices.length == 0 &&
                        React.createElement(Alert, { severity: "warning", variant: "filled" },
                            React.createElement(AlertTitle, null, _T.EXCURSION_ERROR_DATE_UNAVAIL_TITLE),
                            _T.EXCURSION_ERROR_DATE_UNAVAIL_BODY),
                    props.loading && React.createElement("div", null,
                        React.createElement(CircularProgress, { size: 30 })) || null,
                    React.createElement(Box, { mt: 2 },
                        React.createElement(Button, { color: "primary", variant: "contained", fullWidth: true, disableElevation: true, onClick: handleAddToCart, disabled: props.loading || !props.price },
                            React.createElement(CartIcon, { fontSize: "small" }),
                            "\u00A0",
                            _T.COMMON_BOOK))))));
}
